<template>
  <div class="popup-form">    
    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img
            class="nav-link-icon filter-primary"
            src="@/images/modal-close.svg"
            alt=""
          />
        </div>
        <div class="blackcolor pop-800">Termín {{ getPopUpType() }}</div>
        <button class="w-button" form="event-form" :disabled="submitted || clientBusy">
            Vytvoriť
        </button>
      </div>
      <div class="w-form">
        <span class="clientError" v-if="clientMissing">
          Vyberte alebo vytvorte klienta
        </span>
        <client-picker v-if="needsClientPicker" @client-picked="setClient($event)"
          @busy="clientBusy = $event" :disabled="submitted"
          :broker-id="type.type === 'brokerConsultation' ? $store.getters['userState/getId'] : undefined" complex />
        <div v-if="type.type === 'availability'" class="availability-note">
          Tento termín uvidia klienti, ktorým ste pridelený. Daily videohovor sa bezpečne vytvorí až po rezervácii.
        </div>
        <component
          :is="type.component"
          :availability="type.type === 'availability'"
          :initial-start="initialStart"
          :initial-end="initialEnd"
          @event-saved="saveEvent($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationSignEvent from "./ApplicationSignEvent";
import ContractSignEvent from "./ContractSignEvent"
import OnlineConsultationEvent from "./OnlineConsultationEvent";
import ClientPicker from "../ClientPicker/ClientPicker";

export default {
  name: "ClientEventPopUp",
  components: {
    ClientPicker,
    ApplicationSignEvent,
    ContractSignEvent,
    OnlineConsultationEvent
  },
  props: {
    _googlePlaceId: [String, null],
    type: Object,
    payload: [Number, Object, null],
  },
  computed: {
    needsClientPicker () {
      return ["clientUnknown", "brokerConsultation"].includes(this.type.type);
    },
    initialStart () {
      return this.payload?.start || null;
    },
    initialEnd () {
      return this.payload?.end || null;
    },
  },
  created () {
    if (this.type.type === "brokerConsultationKnown") {
      this.client = this.payload?.client || this.payload;
    }
  },
  methods: {
    getPopUpType () {
      if (this.type.component === "ApplicationSignEvent") {
        return "podpisu žiadostí";
      } else if (this.type.component === "ContractSignEvent") {
        return "podpisu úverovej zmluvy";
      } else if (this.type.component === "OnlineConsultationEvent") {
        return this.type.type === "availability" ? "pre klientov" : "online konzultácie";
      }
    },
    async saveEvent (eventData) {
      if (this.submitted || this.clientBusy) return;
      if (this.needsClientPicker && !this.client) {
        this.clientMissing = true;
        return;
      }
      if (this.type.type === 'clientKnown') {
        this.client = {id: this.payload};
      }
      this.clientMissing = false;
      this.submitted = true;
      const myId = this.$store.getters["userState/getId"];
      if (this.type.type === 'availability') {
        eventData.users = [myId];
        eventData.is_available_for_booking = true;
      } else {
        eventData.users = [this.client.id, myId];
      }
      try {
        if (["brokerConsultation", "brokerConsultationKnown"].includes(this.type.type)) {
          await this.$store.dispatch("clientsEvents/scheduleConsultation", {
            eventData,
            client: this.client,
          });
          this.$store.commit("clientsEvents/setConsultationClient", null);
        } else {
          await this.$store.dispatch("clientsEvents/createEvent", {eventData, client: this.client});
        }
        this.closePopup();
      } catch (error) {
        this.submitted = false;
      }
      // if (this.client && this.client.mortgages.length > 1) {
      //   this.$store.commit("popupManagerState/pushToPopupOrder", {
      //     type: null,
      //     payload: {mortgages: this.client.mortgages, id: this.client.id, title: 'PICK'},
      //     component: "MortgagePickerPopUp",
      //     rules: this.rules,
      //   });
      // }
    },
    setClient (client) {
      this.client = client;
      if (client) this.clientMissing = false;
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  data: () => ({
    client: null,
    submitted: false,
    clientMissing: false,
    clientBusy: false,
  }),
}
</script>

<style lang="scss" scoped>
.information-wrapper {
  margin-top: 10px;
  display: flex;
  column-gap: 105px;
  flex-direction: column;
  align-items: center;
}

.information-wrapper * {
  margin-top: 10px;
}

.information-wrapper > span {
  text-align: center;
  font-size: 15px;
}

.availability-note {
  margin-bottom: 18px;
  padding: 14px 16px;
  border: 1px solid rgba(47, 133, 216, 0.24);
  border-radius: 12px;
  background: rgba(47, 133, 216, 0.08);
  color: var(--theme-text-muted, #60708d);
  font-size: 13px;
  line-height: 1.5;
}
</style>
